import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
`;

export const InspectionBadge = styled.div`
  display: inline-block;
  width: 8px;
  height: 8px;
  min-width: 8px;
  background-color: #ff4d4f;
  border-radius: 50%;
  margin-left: 8px;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;
